// extracted by mini-css-extract-plugin
module.exports = {"bodyContainer":"Body_bodyContainer__AIdZg","noCubbyText":"Body_noCubbyText__38iOH"};